export default "__VITE_ASSET__39dba7fa__"